// app.companies._index.tsx (B2B companies list + create-company form) +
// app.companies.$id.tsx (single company detail + price-list assignment).
export const companies = {
  pageHeading: "Companies",
  createdBanner: {
    body: "created with a contact and location — it's ready to quote.",
    createQuoteLink: "Create a quote for it",
  },
  loadError: "We couldn't load companies. B2B may not be enabled on this shop, or scopes haven't been granted yet.",
  intro:
    "Every quote is addressed to a B2B company (Shopify's native business-customer record). Create one right here — Quote Desk sets up the contact and location a buyer needs to accept a quote — or manage them in Shopify admin under Customers → Companies.",
  emptyState: {
    heading: "No companies yet — create your first",
    body: "You need at least one company before you can send a quote. Fill in the form below, or create a disposable demo company to try the flow end-to-end.",
    sampleButton: "Create a sample company (demo data)",
    manualRoutePrefix: "Prefer the manual route?",
    manualRouteLink: "Shopify's B2B setup guide",
  },
  list: {
    heading: "Your B2B companies",
    countsLine: "{{locations}} locations · {{contacts}} contacts",
  },
  createSection: {
    headingFirst: "Create a company",
    headingAdditional: "Add another company",
  },
  form: {
    nameLabel: "Company name",
    namePlaceholder: "e.g. Acme Wholesale",
    firstNameLabel: "Contact first name",
    lastNameLabel: "Contact last name",
    emailLabel: "Contact email",
    emailHelpText: "The buyer who'll receive quotes. Shopify creates a customer record for them.",
    locationLabel: "Location name (optional)",
    locationPlaceholder: "Defaults to “<company> — main location”",
    locationHelpText: "Companies need a location before buyers can accept quotes — we create it for you.",
    submitButton: "Create company",
    errors: {
      nameRequired: "Company name is required.",
      firstNameRequired: "Contact first name is required.",
      lastNameRequired: "Contact last name is required.",
      invalidEmail: "Enter a valid contact email.",
      invalidInput: "Invalid input.",
      createFailed:
        "Couldn't create the company — Shopify may not have B2B available on this store yet. You can also create companies in Shopify admin under Customers → Companies.",
      shopifyRejected: "Shopify rejected the company.",
    },
  },
  detail: {
    notFoundHeading: "Company not found",
    notFoundBody: "Could not load company {{id}}.",
    contactsHeading: "Contacts",
    locationsHeading: "Locations",
    priceListHeading: "B2B price list",
    priceListDescription:
      "Assign a price list and every new quote for this company prefills each line from it — the merchant can still override any line before sending.",
    noPriceLists: {
      body: "No active price lists yet.",
      createLink: "Create a price list",
      suffix: "to offer this company negotiated B2B pricing.",
    },
    priceListSelectLabel: "Assigned price list",
    noneOption: "None (use catalog prices)",
    saveAssignmentButton: "Save assignment",
    actionsHeading: "Actions",
    createQuoteButton: "Create a quote for this company",
    messages: {
      removed: "Removed price list from this company.",
      assigned: "Price list assigned. New quotes for this company will prefill from it.",
      assignFailed: "That price list or company no longer exists.",
    },
  },
};
